module.exports = __webpack_public_path__ + "static/media/photo279.1a1a6ed8.jpg";